import './Book.css';
import BookInfo from "./BookInfo.js"
import { processTouchCodeURS } from "./func/bookend-api.js"
import { useState } from 'react';

function Book(props) {

 const { cInfo, code, project, isInvalid, errorMessage } = props;
 const img_url = cInfo.ThumbnailURL;
 const [mailAddress, setMailAddress] = useState('');
 const [isPageTurned, setIsPageTurned] = useState(false); // 2ページ目がめくれた状態を管理
 const [generatedPassword, setGeneratedPassword] = useState(''); // パスワードを管理
 const [isFlipped, setIsFlipped] = useState(false); // 表紙がめくれた状態を管理するstate

 const btn_style = {};

  // 本全体がクリックされたときの処理
  const handleBookClick = () => {
   // 無効なカードの場合はめくれないようにする
   if (isInvalid) {
    return;
   }
   // まだめくれていない場合のみ、めくる
   if (!isFlipped) {
    setIsFlipped(true);
   }
  };

  // パスワードをクリップボードにコピーする処理
  const handleCopyPassword = (e) => {
    // 親要素へのイベント伝播を停止し、本のクリックイベントが発火しないようにする
    e.stopPropagation();

    navigator.clipboard.writeText(generatedPassword).then(() => {
      alert('パスワードをコピーしました');
    }).catch(err => {
      console.error('クリップボードへのコピーに失敗しました:', err);
      alert('コピーに失敗しました。');
    });
  };

 return (
   <figure className={`book ${isFlipped ? 'flipped' : ''} ${isPageTurned ? 'page-turned' : ''} ${isInvalid ? 'invalid' : ''}`} style={btn_style} onClick={handleBookClick}>
    <div className='hardcover_front'>
      <div className="coverDesign">
       {isInvalid && (
        <div className="error-overlay">
         <p>{errorMessage}</p>
        </div>
       )}
       {/*<span className="ribbon">NEW</span>*/}
       <img src={img_url} alt="thumb"></img>
      </div>
     <div></div>
    </div>
    <ul className='page'>
     <li>
      <div className="page-content"></div>
     </li>
     <li>
      <div className="page-content">
        <BookInfo cInfo={cInfo}/>
        {!isInvalid && (
          <>
            <div className="mail_input">
              <label htmlFor="mailAddress">メールアドレス：</label>
              <input id="mailAddress" type="text" onChange={(e) => setMailAddress(e.target.value)} ></input>
            </div>
            <div className="btn" onClick={registration}>登録</div>
          </>
        )}
      </div>
     </li>
     <li>
      <div className="page-content">
        {isPageTurned && (
          <div className="password-notification">
              {generatedPassword === '登録完了' ? (
                  <>
                      <h2>あなたのアカウントにコンテンツグループを追加しました。</h2>
                      <p>読み放題サービスにログインしてご確認ください。</p>
                  </>
              ) : (
                  <>
                      <h2>新規にアカウントを登録しました。</h2>
                      <p>あなたのパスワードはこちらです:</p>
                      <div className="password-container">
                        <strong className="password-display">{generatedPassword}</strong>
                        <button onClick={handleCopyPassword} className="copy-button">コピー</button>
                      </div>
                  </>
              )}
          </div>
        )}
      </div>
     </li>
     <li>
      <div className="page-content"></div>
     </li>
     <li>
      <div className="page-content"></div>
     </li>
     <li>
      <div className="page-content"></div>
     </li>
    </ul>
    <ul className='hardcover_back'>
     <li></li>
     <li></li>
    </ul>
    <ul className='book_spine'>
     <li></li>
     <li></li>
    </ul>
   </figure>
 );

function registration(e){
  // 親要素(figure)へのクリックイベントの伝播を防ぐ
  e.stopPropagation();

  if(cInfo.ProjectType === "2"){
    if (!mailAddress) {
      alert('メールアドレスを入力してください。');
      return;
    }
    processTouchCodeURS(code, project, mailAddress, alertPassword);
  }
 }

 function alertPassword(data){
  // 2ページ目をめくる
  setIsPageTurned(true);
  if (data && data.password) {
    setGeneratedPassword(data.password);
  } else {
    setGeneratedPassword('登録完了');
  }
 }
}

export default Book;